import React, { useEffect, useState } from 'react'
import '../Assets/css/vendor.min.css';
import '../Assets/css/style.css';
import '../Assets/css/media.css';
import { Link } from 'react-router-dom';
import { BASE_URL } from '../config';
import axios from 'axios';

const Footer = () => {
    const [contactInfo, setContactInfo] = useState({
        phone: '',
        email: ''
    });

    useEffect(() => {
        axios.get(`${BASE_URL}/site-settings`)
            .then(res => {
                if (res.data.status === 200 && res.data.data) {
                    const data = res.data.data;
                    setContactInfo({
                        phone: data.site_phone_number || '',
                        email: data.site_email || ''
                    });
                }
            })
            .catch(err => {
                console.error("Failed to fetch contact info:", err);
            });
    }, []);

    return (
        <footer className="footercontainer">
            <div className="footerinfo">
                <a href="tel:+18023029002">{contactInfo.phone}</a>
                <a href="mailto:Sales@rcacapacitors.com">{contactInfo.email}</a>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <p>&copy; {new Date().getFullYear()} <Link to="/">RCA Capacitors</Link>. All Rights Reserved.</p>
                    </div>
                </div>
            </div>
        </footer>


    )
}

export default Footer